// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RadioItem__wrapper___LYNgq","disabled":"RadioItem__disabled___M5sdA","main":"RadioItem__main___tSPhI"};